// extracted by mini-css-extract-plugin
export var aniSpin = "D_d";
export var item = "D_q";
export var item__inner = "D_bb";
export var item__quote = "D_7";
export var item__source = "D_9";
export var item__stars = "D_8";
export var items = "D_6";